import { useState, useEffect } from 'react';

const useCountry = () => {
    const [country, setCountry] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const detectLocation = async () => {
            try {
                const response = await fetch('https://ipapi.co/json/');
                const data = await response.json();
                setCountry(data.country_code);
            } catch (error) {
                console.error('Error detecting location:', error);
                setCountry('UNKNOWN');
            } finally {
                setLoading(false);
            }
        };

        detectLocation();
    }, []);

    return { country, loading };
};

export default useCountry;
